export default __webpack_public_path__ + "static/media/gamestack-login.a1efedd0.jpg";